/** @format */

import { _1 } from './1'
import { _3 } from './3'
import { _4 } from './4'
import { _5 } from './5'
import { _6 } from './6'
import { _7 } from './7'
import { _9 } from './9'

const obj = { _1, _3, _4, _5, _6, _7, _9 }

export default obj
